import React, { FC, ReactNode, useState } from 'react';
import './PasswordField.css';
import { ErrorMessage, Field } from '@/Shared/Lib/Logic';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface PasswordFieldProps {
	label?: string,
	icon?: ReactNode,
	name: string,
	placeholder?: string,
	autoComplete?: string,
	readOnly?: boolean
	required?: boolean,
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
	value?: any,
}

const PasswordField: FC<PasswordFieldProps> = ({
	label,
	icon,
	name,
	placeholder,
	autoComplete,
	readOnly = false,
	required = false,
	onChange,
	value
}) => {

	const [type, setType] = useState<'text' | 'password'>('password');
	
	
	return(

	<label
		className={`PasswordField data-field-label ${readOnly ? 'readonly' : ''}`}
		data-testid="PasswordField"
		title={readOnly ? 'Champ non modifiable' : 'Champ modifiable'}>
		{label && <div>{label} {required && <span className="asterisk" aria-hidden="true"> *</span>}</div>}
		<div className="form-group">
			<div className='Field-wrapper'>
				{icon && <div className='field-icon'>{icon}</div>}
				<Field
					readOnly={readOnly}
					id={name}
					name={name}
					type={type}
					className="input-field"
					placeholder={placeholder || label}
					autoComplete={autoComplete || 'off'}
					{...(onChange ? { onChange } : {})}
					{...(value ? { value } : {})}
				/>
				<div className='field-icon right cursor-pointer' onClick={() => {
					setType(prev=> prev === 'text' ? 'password' : 'text');
				}}>{type === 'password' ? <FaEye/> : <FaEyeSlash/> }</div>
			</div>
			<ErrorMessage name={name} component="div" className="error-message" />
		</div>
	</label>
);
}
export default PasswordField;
